<div class="container login-form-ui">
    <div class="row w-100 mx-0 auth-page">
        <div class="col-md-8 col-xl-6 mx-auto">
            <div class="card">
                <div class="row">
                    <div class="col-md-4 pe-md-0">
                        <div class="auth-side-wrapper">

                        </div>
                    </div>
                    <div class="col-md-8 ps-md-0">
                        <div class="auth-form-wrapper px-4 py-5">
                            <a routerLink="." class="coh-logo d-block mb-2">
                                <span class="coh-logo-text">Flint Housing</span>
                                <span class="coh-tagline">Customer Care</span>
                              </a>
                            <h5 class="text-secondary fw-normal mb-4">Enter Your OTP</h5>
                            <form [formGroup]="otpForm" class="forms-sample">
                                <div class="mb-5">
                                    <!-- <div class="otp-container">
                                        <input
                                          *ngFor="let ctrl of otpControls; let i = index"
                                          type="text"
                                          maxlength="1"
                                          type="password"
                                          class="otp-input"
                                          formControlName="{{ctrl}}"
                                          (input)="onInput($event, i)"
                                          (keydown)="onKeydown($event, i)"
                                        />
                                      </div> -->
                                      <div class="otp-container position-relative">
                                        <input
                                          *ngFor="let ctrl of otpControls; let i = index"
                                          [type]="otpVisible ? 'text' : 'password'"
                                          maxlength="1"
                                          class="otp-input"
                                          formControlName="{{ctrl}}"
                                          (input)="onInput($event, i)"
                                          (keydown)="onKeydown($event, i)"
                                        />
                                        
                                        <!-- Toggle Button Positioned Absolutely -->
                                        <button
                                          type="button"
                                          class="btn btn-sm btn-outline-secondary toggle-otp-btn"
                                          (click)="otpVisible = !otpVisible"
                                        >
                                          <i class="feather" [ngClass]="otpVisible ? 'icon-eye-off' : 'icon-eye'"></i>
                                        </button>
                                      </div>
                                      
                                </div>
                                <div>
                                    <button type="submit" class="btn btn-primary me-2 mb-2 mb-md-0" (click)="onSubmit()">Verify OTP</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>